import { createFileRoute } from "@tanstack/react-router";

import ConfirmChangeEmail from "./-components/ConfirmChangeEmail";

export const Route = createFileRoute(
  "/_app/_dashboard/profile/changeemail/$confirmation/confirm"
)({
  component: ConfirmChangeEmail,
});
